import { formatDateTime } from '../../utils/dateHelpers';

/** Timeline item */
export default function TimelineItem({ label, date }) {
  return (
    <div style={{
      ...styles.timelineItem,
      opacity: date ? 1 : 0.4,
    }}>
      <div style={{
        ...styles.timelineDot,
        background: date ? 'var(--cp-success)' : 'var(--cp-border)',
      }} />
      <div>
        <div style={styles.timelineLabel}>{label}</div>
        {date && <div style={styles.timelineDate}>{formatDateTime(date)}</div>}
      </div>
    </div>
  );
}

// Timeline style keys (F1b). Defined once here; FileDetail re-attaches the
// three it still uses for the rejection entry. View -> component only.
export const styles = {
  timelineItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.6rem',
    padding: '0.4rem 0',
    borderLeft: '2px solid var(--cp-surface-alt)',
    marginLeft: '5px',
    paddingLeft: '0.75rem',
  },
  timelineDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
    marginTop: '4px',
    marginLeft: '-0.95rem',
  },
  timelineLabel: {
    fontSize: '0.8rem',
    fontWeight: 500,
    color: 'var(--cp-text)',
  },
  timelineDate: {
    fontSize: '0.7rem',
    color: 'var(--cp-text-muted)',
  },
};
